import {Box, Grid, Paper} from "@material-ui/core";
import {TextValidator} from "react-material-ui-form-validator";
import React from "react";
import {PhoneInputValidator} from "../../utilities/validators";
import ImageField from "../../utilities/components/ImageField/ImageField";

const AdminForm = ({
                     classes,
                     croppedImageFile,
                     rowImageFile,
                     setRowImageFile,
                     showImageEditor,
                     setShowImageEditor,
                     setCropper,
                     onImageCrop,
                     email,
                     setEmail,
                     handleSearchUserByEmail,
                     phone,
                     isDisabled,
                     setPhone,
                     firstname,
                     setFirstname,
                     lastname,
                     setLastname,
                   }) => {
  return (
    <Box component={Paper} className={classes.formContainer}>
      <Grid container spacing={2} justify="space-around">
        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
          {isDisabled ? (
            <Box>
              <img
                src={croppedImageFile}
                alt="profile"
                className={`${classes.circleContainer} ${classes.circleImage}`}
              />
            </Box>
          ) : (
            <Box>
              <ImageField
                rowImageFile={rowImageFile}
                setRowImageFile={setRowImageFile}
                showImageEditor={showImageEditor}
                setShowImageEditor={setShowImageEditor}
                setCropper={setCropper}
                croppedImageFile={croppedImageFile}
                onImageCrop={onImageCrop}
                options={{
                  shape: "circle",
                }}
              />
            </Box>
          )}
        </Grid>

        <Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <TextValidator
                label="Email *"
                variant="outlined"
                fullWidth
                size="small"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onBlur={handleSearchUserByEmail}
                validators={["required", "isEmail"]}
                errorMessages={[
                  "Email is required",
                  "Please enter valid email",
                ]}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <PhoneInputValidator
                disabled={isDisabled}
                autoFormat={false}
                variant="outlined"
                size="small"
                label="Phone *"
                fullWidth
                defaultCountry="in"
                countryCodeEditable={false}
                value={phone}
                onChange={(phone) => {
                  let phoneNumber = "+" + phone.replace(/[^0-9]+/g, "");
                  setPhone(phoneNumber);
                }}
                validators={["required", "isValidMobile"]}
                errorMessages={[
                  "Phone is required",
                  "Please enter valid phone",
                ]}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <TextValidator
                disabled={isDisabled}
                label="First Name *"
                variant="outlined"
                fullWidth
                size="small"
                value={firstname}
                onChange={(e) => setFirstname(e.target.value)}
                validators={[
                  "required",
                  "isBlank",
                  "isMaxLength",
                  "noSpecialChars",
                ]}
                errorMessages={[
                  "First name is required",
                  "Please enter first name",
                  "Maximum 100 letters are accepted.",
                  "Only letters and spaces are allowed",
                ]}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <TextValidator
                disabled={isDisabled}
                label="Last Name *"
                variant="outlined"
                fullWidth
                size="small"
                value={lastname}
                onChange={(e) => setLastname(e.target.value)}
                validators={[
                  "required",
                  "isBlank",
                  "isMaxLength",
                  "noSpecialChars",
                ]}
                errorMessages={[
                  "Last name is required",
                  "Please enter last name",
                  "Maximum 100 letters are accepted.",
                  "Only letters and spaces are allowed",
                ]}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdminForm;
